export const worksheetReportTemplateConfigKeys = {
  all: ['worksheetReportTemplateConfig'] as const,
  lists: () => [...worksheetReportTemplateConfigKeys.all, 'list'] as const,
  list: (filters: string) => [...worksheetReportTemplateConfigKeys.lists(), { filters }] as const,
} as const;